import { VStack } from '@chakra-ui/react'
import React from 'react'

const OurClient = () => {
  return (
    <VStack // bore  padding={{base:"20px",md:"50px 100px"}}
    borderColor={"none"}  alignSelf="center" spacing={5} 
   >

    
   </VStack>
  )
}

export default OurClient
